module.exports = __webpack_public_path__ + "img/kong2.4d49bec7.png";